import React from 'react'

function KeyWord() {
  return (
    <div>KeyWord</div>
  )
}

export default KeyWord;